import {
  Button,
  Grid,
  Typography,
  Modal,
  Checkbox,
  TextField,
  InputAdornment,
  IconButton,
  Select,
  MenuItem,
  CircularProgress,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ValuoTable from "../ValuoTable";
import { actions, service } from "../../model";
import ModalConferma from "../Generics/ModalConferma";
import ModalSuccess from "../Generics/ModalSuccess";
import ModalError from "../Generics/ModalError";

const DashboardPartner = ({
  user,
  collaborators,
  evaluations,
  loadAppData,
  apiErrorModalGeneral,
}) => {
  const dispatch = useDispatch();
  const reduxObject = useSelector((state) => state.user?.redux_object);
  const token = reduxObject.accessToken;

  const [loading, setLoading] = useState(false);
  // const [openConfirmStartValuo, setOpenConfirmStartValuo] = useState(false);
  const [modalOpenStartValuo, setModalOpenStartValuo] = useState(false);
  const [openSuccessStartValuo, setOpenSuccessStartValuo] = useState(false);
  const [apiErrorModal, setApiErrorModal] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);

  const anniDisponibili = [
    ...new Set(evaluations?.map((el) => el.year || null)),
  ];

  const availableIds = useMemo(() => {
    return (
      collaborators
        ?.map((c) => c?.collaborator?.id)
        .filter(
          (id) =>
            id !== undefined &&
            !evaluations?.some((e) => e.collaborator?.id === id)
        ) || []
    );
  }, [collaborators, evaluations]);

  const allChecked =
    availableIds.length > 0 &&
    availableIds.every((id) => selectedIds.includes(id));

  const evaluationsFiltered = useMemo(() => {
    return (
      evaluations?.filter((item) => {
        const name = item.collaborator?.name || "";
        const year = item.data_partner?.anno || item.year;

        const matchesSearch = searchTerm
          ? name.toLowerCase().includes(searchTerm.trim().toLowerCase())
          : true;

        const matchesYear = selectedYear ? year === selectedYear : true;

        return matchesSearch && matchesYear;
      }) || []
    );
  }, [searchTerm, selectedYear, evaluations]);

  const allAlreadyStarted =
    Array.isArray(collaborators) &&
    collaborators.every((c) =>
      evaluations?.some((e) => e.collaborator?.id === c?.collaborator?.id)
    );

  useEffect(() => {
    if (!Array.isArray(collaborators)) return;
    setSelectedIds([]);
  }, [collaborators, evaluations]);

  const handleModalClick = () => setModalOpenStartValuo(true);
  const handleCloseModal = () => setModalOpenStartValuo(false);

  const handleSubmitUpdateUser = async () => {
    setLoading(true);
    setApiErrorModal(false);
    setOpenSuccessStartValuo(false);

    try {
      const allSelected = availableIds.every((id) => selectedIds.includes(id));

      if (allSelected) {
        await service.startAllEvaluo(token);
      } else {
        for (const id of selectedIds) {
          await service.startSingleEvaluo(token, id);
        }
      }

      setModalOpenStartValuo(false);
      setOpenSuccessStartValuo(true);
    } catch (error) {
      console.error("Errore", error);
      setApiErrorModal(true);
    } finally {
      loadAppData();
      setSelectedIds([]);
      setTimeout(() => {
        setLoading(false);
      }, 600);
    }
  };

  const closeModalSuccessStart = () => {
    setOpenSuccessStartValuo(false);
  };

  const handleCheckboxChange = (id) => {
    const alreadyStarted = evaluations?.some((e) => e.collaborator?.id === id);
    if (alreadyStarted) return;

    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((userId) => userId !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (allChecked) {
      setSelectedIds([]);
    } else {
      setSelectedIds(availableIds);
    }
  };

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const getTeamName = (teamsString) => {
    try {
      const teamsObj = JSON.parse(teamsString);
      return Object.keys(teamsObj)[0] || "";
    } catch {
      return "";
    }
  };

  return (
    <>
      <Grid
        item
        xs={11}
        md={9}
        justifyContent="center"
        alignItems="flex-start"
        sx={{ width: "100%", paddingY: "40px" }}
      >
        {/* BOX AVVISO */}
        {!apiErrorModalGeneral && !allAlreadyStarted ? (
          <Grid
            item
            xs={12}
            sx={{
              backgroundColor: "#fae63436",
              padding: "20px",
              color: "#1b2838",
              height: "fit-content",
              mb: 3,
            }}
          >
            <Grid container spacing={2} alignItems="stretch">
              <Grid item xs={12} md={9} sx={{ display: "flex" }}>
                <div
                  className="icon-info"
                  style={{
                    marginRight: "10px",
                    marginTop: "1px",
                    flexShrink: 0,
                  }}
                />
                <Box>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: 600,
                      color: "#1b2838",
                      mb: 0.5,
                    }}
                  >
                    Processo di valutazione annuale abilitato
                  </Typography>
                  <Typography>
                    Seleziona i professionisti del tuo team con i quali avviare
                    la valutazione annuale.
                  </Typography>
                </Box>
              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  justifyContent: { xs: "flex-end" },
                  alignItems: { xs: "flex-end" },
                }}
              >
                <Button
                  variant="contained"
                  className="button-bg-purple"
                  onClick={handleModalClick}
                  style={{ boxShadow: "none" }}
                >
                  <Typography
                    className="color-light"
                    sx={{
                      textTransform: "initial",
                      fontSize: { xs: "16px", sm: "18px" },
                      fontWeight: 500,
                    }}
                  >
                    Seleziona
                  </Typography>
                </Button>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Typography sx={{ mb: 2, fontSize: 22, fontWeight: 600 }}>
            Lista valutazioni
          </Typography>
        )}

        {/* SEARCHBAR */}
        {evaluations && evaluations.length > 0 && (
          <Grid
            container
            spacing={2}
            sx={{
              marginTop: "20px",
              marginBottom: "30px",
              justifyContent: "flex-start",
            }}
          >
            <Grid
              item
              xs={12}
              md={6}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <TextField
                placeholder="Ricerca per professionista"
                fullWidth
                variant="outlined"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                InputProps={{
                  endAdornment: searchTerm && (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="clear search"
                        onClick={handleClearSearch}
                        edge="end"
                        sx={{
                          color: "#1b2838",
                          "&:hover": { backgroundColor: "transparent" },
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "grey", borderWidth: "1px" },
                    "&:hover fieldset": {
                      borderColor: "#1b2838",
                      borderWidth: "1px",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#1b2838",
                      borderWidth: "1px",
                    },
                  },
                  "& input::placeholder": { fontSize: "14px" },
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={3}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Select
                fullWidth
                displayEmpty
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                renderValue={(selected) => {
                  if (selected === "")
                    return (
                      <span style={{ color: "#9d9d9e" }}>Seleziona anno</span>
                    );
                  return (
                    <span style={{ color: "#1b2838", fontWeight: 500 }}>
                      {selected}
                    </span>
                  );
                }}
                sx={{
                  height: "100%",
                  "& .MuiSelect-select": {
                    color: "#1b2838 !important",
                    py: 1.2,
                  },
                  "& .MuiSvgIcon-root": { color: "#9d9d9eff" },
                }}
              >
                <MenuItem value="">
                  <span className="color-blue-dark">Seleziona anno</span>
                </MenuItem>
                {anniDisponibili.map((anno) => (
                  <MenuItem key={anno} value={anno}>
                    <Typography sx={{ color: "#1b2838" }}>{anno}</Typography>
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
        )}

        {evaluations && evaluations.length > 0 && (
          <ValuoTable evaluations={evaluationsFiltered} user={user} />
        )}
      </Grid>

      <Modal open={modalOpenStartValuo} onClose={handleCloseModal}>
        <Grid
          container
          item
          xs={11}
          md={5}
          sx={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            maxHeight: "90vh",
            overflowY: "auto",
            outline: "none",
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              borderBottom: "1px solid #c6c6c6",
              p: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              className="color-blue-dark"
              sx={{ fontSize: "18px", fontWeight: 600 }}
            >
              Seleziona professionisti
            </Typography>
            <div
              onClick={handleCloseModal}
              className="icon-modal-close"
              style={{ cursor: "pointer" }}
            />
          </Grid>

          <Grid item xs={12} sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              style={{
                padding: "0px 15px 5px 15px",
                marginTop: "20px",
              }}
              className="color-blue-dark"
            >
              I professionisti selezionati riceveranno un’email per iniziare la
              propria autovalutazione.
            </Typography>
          </Grid>

          {/* SELECT ALL */}
          {!allAlreadyStarted && (
            <Grid container alignItems="center" sx={{ px: 1.5, mt: 1.5 }}>
              <Checkbox
                checked={allChecked}
                onChange={handleSelectAll}
                sx={{
                  color: "#1b2838",
                  "&.Mui-checked": { color: "#1b2838" },
                  "&:hover": { backgroundColor: "transparent" },
                }}
              />
              <Typography sx={{ fontWeight: 500 }}>Seleziona tutti</Typography>
            </Grid>
          )}

          {/* Lista utenti */}
          <Grid item xs={12} sx={{ mt: 1 }}>
            {Array.isArray(collaborators) &&
              collaborators.map((c) => {
                const col = c?.collaborator;
                if (!col) return null;

                const alreadyStarted = evaluations?.some(
                  (e) => e.collaborator?.id === col.id
                );

                return (
                  <Grid
                    container
                    key={col.id}
                    alignItems="center"
                    sx={{
                      borderBottom: "1px solid #eee",
                      py: 0.5,
                      backgroundColor: alreadyStarted
                        ? "#f5f5f5bb"
                        : "transparent",
                      opacity: alreadyStarted ? 0.8 : 1,
                      px: 4,
                      py: 0.7,
                      width: "100%",
                      mt: "-8px",
                    }}
                  >
                    <Grid item xs={1}>
                      <Checkbox
                        checked={selectedIds.includes(col.id)}
                        onChange={() => handleCheckboxChange(col.id)}
                        disabled={alreadyStarted}
                        sx={{
                          color: "#1b2838",
                          "&.Mui-checked": { color: "#1b2838" },
                          "&:hover": { backgroundColor: "transparent" },
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={11}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography sx={{ fontWeight: 500 }}>
                        {col.name} -
                        {col.teams && (
                          <span
                            style={{
                              fontSize: "14px",
                              color: "#666",
                              marginLeft: "6px",
                              fontWeight: 400,
                            }}
                          >
                            {getTeamName(col.teams)}
                          </span>
                        )}
                      </Typography>
                      {alreadyStarted && (
                        <Typography sx={{ fontWeight: 500, color: "#666" }}>
                          (Processo avviato)
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                );
              })}
          </Grid>

          {/* Footer */}
          {allAlreadyStarted ? (
            <Grid
              item
              xs={12}
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "flex-start",
                gap: 2,
                p: 2,
              }}
            >
              <Button
                onClick={() => setModalOpenStartValuo(false)}
                variant="outlined"
                className="button-bg-empty"
                style={{ boxShadow: "none" }}
              >
                <Typography
                  className="color-blue-dark"
                  sx={{
                    textTransform: "initial",
                    fontSize: { xs: "16px", sm: "18px" },
                    fontWeight: 500,
                  }}
                >
                  Chiudi
                </Typography>
              </Button>
            </Grid>
          ) : (
            <Grid
              item
              xs={12}
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                p: 2,
              }}
            >
              <Button
                onClick={handleSubmitUpdateUser}
                variant="contained"
                className={
                  selectedIds.length === 0
                    ? "button-bg-purple-disable"
                    : "button-bg-purple"
                }
                disabled={selectedIds.length === 0}
                style={{ boxShadow: "none" }}
              >
                <Typography
                  className="color-light"
                  sx={{
                    textTransform: "initial",
                    fontSize: { xs: "16px", sm: "18px" },
                    fontWeight: 500,
                  }}
                >
                  Avvia processo
                </Typography>
              </Button>
            </Grid>
          )}
        </Grid>
      </Modal>

      <Modal open={openSuccessStartValuo} onClose={closeModalSuccessStart}>
        <ModalSuccess
          title="Processo avviato"
          descriptionOne="Attendi che i professionisti selezionati completino la propria autovalutazione."
          descriptionTwo=""
          copyButton="Chiudi"
          confirm={closeModalSuccessStart}
          onClose={closeModalSuccessStart}
        />
      </Modal>

      <Modal open={apiErrorModal} onClose={() => setApiErrorModal(false)}>
        <ModalError
          title="Ops, qualcosa è andato storto"
          descriptionOne="Si è verificato un errore tecnico momentaneo."
          descriptionTwo="Ti invitiamo a riprovare tra qualche minuto. Grazie."
          copyButton="Chiudi"
          confirm={() => setApiErrorModal(false)}
          onClose={() => setApiErrorModal(false)}
        />
      </Modal>

      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress sx={{ color: "#1b2838" }} />
        </div>
      )}
    </>
  );
};

export default DashboardPartner;
